import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const FaviconUpdater = () => {
    const [defaultFavicon] = useState(document.querySelector("link[rel='icon']").href); // Store original favicon
 const favicon = useSelector(state=>state.data.orgItem);

  useEffect(() => {
    if (favicon?.favicon) {
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = favicon?.favicon || defaultFavicon; // Update the favicon
      }
    }
    }, [favicon?.favicon, defaultFavicon]);

  return null; // This component doesn't render anything
};

export default FaviconUpdater;
